/** Canonical public website origin — production only. */
export const SITE_ORIGIN = 'https://www.perfectpredict.com' as const

export const SITE_NAME = 'Perfect Predict' as const

export const DEFAULT_OG_IMAGE_PATH = '/pwa/client/icon-512.png' as const

export const THEME_COLOR = '#1E4DB7' as const

export function absoluteUrl(path: string): string {
  if (!path) return SITE_ORIGIN
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${SITE_ORIGIN}${normalized}`
}

export function defaultOgImageUrl(): string {
  return absoluteUrl(DEFAULT_OG_IMAGE_PATH)
}
